// API Request
// ------------------------------
export type ListGeoSegment = {
    usage: string;
    accountId: number;
};

export type CreateGeoSegment = {
    name: string;
    description: string;
    usage: string;
    createdBy: number;
    accountGroupId: number;
    geoPointInput: Array<GeoPointInput>;
};

export type GeoPointInput = {
    type: number;
    latitude: string;
    longitude: string;
    areaWidth: string;
    wifiApId: string;
    name: string;
    address: string;
    dateFrom: string;
    dateTo: string;
}

export type UpdateGeoSegment = {
    id: number;
    name: string;
    description: string;
    usage: string;
    updatedBy: number;
    accountGroupId: number;
    coordinatedAccount: number[];
    expectedVersion: number;
};

export type DeleteGeoSegment = {
    id: number;
    updatedBy: number;
    expectedVersion: number;
};

export type GeoSegment = {
    id: number;
    name: string;
    description: string;
    uu: number;
    usage: string;
    coordinatedAccount: string | number[];
    createdAt: string;
    createdBy: number;
    updatedAt: string;
    updatedBy: number;
    accountGroupId: number;
};

export type ResListGeoSegment = {
    id: number;
    name: string;
    status: string;
    description: string;
    uu: number;
    coordinatedAccount: string | number[];
    usage: string;
    accountGroupId: number;
    updatedAt: string;
    updatedBy: string;
    geoPoints: Array<GeoPoint>;
};

export type ResGetGeoSegment = {
    name: string;
    description: string;
    status: string;
    usage: string;
    coordinatedAccount: string | number[];
    accountGroupId: number;
    uu: number;
    createdAt: string;
    createdBy: number;
    updatedAt: string;
    updatedBy: number;
    version: number;
    geoPoints: Array<GeoPoint>;
};

export type GeoPoint = {
    id: string;
    geoPointId: string;
    segmentId: string;
    type: number;
    latitude: string;
    longitude: string;
    areaWidth: string;
    wifiApId: string;
    name: string;
    address: string;
    dateFrom: string;
    dateTo: string;
}

export const initResGetGeoSegment: ResGetGeoSegment = {
    name: "",
    description: "",
    status: "",
    usage: "",
    coordinatedAccount: "",
    accountGroupId: 0,
    uu: 0,
    createdAt: "",
    createdBy: 0,
    updatedAt: "",
    updatedBy: 0,
    version: 0,
    geoPoints: [{
        id: "",
        geoPointId: "",
        segmentId: "",
        type: 0,
        latitude: "",
        longitude: "",
        areaWidth: "",
        wifiApId: "",
        name: "",
        address: "",
        dateFrom: "",
        dateTo: "",
    }]
};

// Enum
// ------------------------------
export const AreaWidthValue = {
    R75: "75",
    R250: "250",
    R500: "500",
    R1000: "1000",
    R2000: "2000",
    R5000: "5000",
    R1KM: "1",
    R2KM: "2",
    R5KM: "5",
} as const;
export type AreaWidthValue = typeof AreaWidthValue[keyof typeof AreaWidthValue];

export const Status = {
    Available: "AVAILABLE",
    Processing: "PROCESSING",
    Unavailable: "UNAVAILABLE",
} as const;
export type Status = typeof Status[keyof typeof Status];

export const Usage = {
    Temporary: "TEMPORARY",
    Production: "PRODUCTION",
} as const;
export type Usage = typeof Usage[keyof typeof Usage];

// Other
// ------------------------------
export type AccountCoordinates = {
    id: Array<number>;
    name: string;
};
  
export const initAccountCoordinates: AccountCoordinates = {
    id: [],
    name: "",
};

export const SegmentProcessType = {
    create: "create",
    edit: "edit",
}

// const
// ------------------------------
export const DefaultLat = 35.681349;
export const DefaultLng = 139.767146;
export const DefaultZoom = 12;
export const DefaultListZoom = 11;
export const MaxArea = 50;
export const AddressPlaceholder = "住所/建物名/施設名等を入力してください";

export const GoogleMapsApiKey = "AIzaSyDaqu2MgrEjr4RVNIRrqbNLkVI72Trigcw";